function stringifyRibbonLabel(ribbonIdent, language) {
  if (ribbonIdent === undefined) {
    return undefined;
  }
  const labelMap = (() => {
    switch (language) {
      case "English":
        return englishLabels;
      case "French":
        return frenchLabels;
      case "German":
        return germanLabels;
      default:
        return danishLabels;
    }
  })();
  const labelId = Object.hasOwn(identMapping, ribbonIdent) ? identMapping[ribbonIdent] : ribbonIdent;
  const label = labelMap[labelId];
  if (!label) {
    if (!missingRibbonIdentWarnings.has(ribbonIdent)) {
      missingRibbonIdentWarnings.add(ribbonIdent);
      console.warn(`stringifyRibbonLabel(): unable to identify label for ribbon with id:`, ribbonIdent);
    }
    return undefined;
  }
  return label;
}
const missingRibbonIdentWarnings = new Set();
const identMapping = {
  "♣": "aktivitet",
  "´": "bevægelse",
  bevaegelse: "bevægelse",
  l: "citat",
  j: "eksempel",
  ")": "evaluering",
  k: "fakta",
  faktaboks: "fakta",
  "---": "geogebra",
  "½": "lærervejledning",
  laerevejledning: "lærervejledning",
  "♥": "læseguide",
  laeseguide: "læseguide",
  "~": "mundtlig-opgave",
  Ў: "mål",
  maal: "mål",
  "|": "opgave",
  p: "gruppe",
  "opgave-gruppe": "gruppe",
  q: "alene",
  "opgave-individuel": "alene",
  ϼ: "klasse",
  "opgave-klasse": "klasse",
  o: "par",
  "opgave-par": "par",
  "₦": "skriftlig-opgave",
  "₧": "spil",
  "₪": "udfordring",
  udfordringsopgave: "udfordring",
  "₫": "undersøgelse",
  "undersoegelse-eksperiment": "undersøgelse"
};
const danishLabels = {
  aktivitet: "Aktivitet",
  bevægelse: "Bevægelse",
  citat: "Citat",
  eksempel: "Eksempel",
  evaluering: "Evaluering",
  fakta: "Fakta",
  geogebra: "GeoGebra",
  lærervejledning: "Lærervejledning",
  læseguide: "Læseguide",
  "mundtlig-opgave": "Mundtlig opgave",
  mål: "Mål",
  opgave: "Opgave",
  gruppe: "I grupper",
  alene: "Alene",
  klasse: "Hele klassen",
  par: "I par",
  "skriftlig-opgave": "Skriftlig opgave",
  spil: "Spil",
  udfordring: "Udfordring",
  undersøgelse: "Undersøgelse"
};
const englishLabels = {
  aktivitet: "Activity",
  bevægelse: "Move",
  citat: "Quote",
  eksempel: "Example",
  evaluering: "Evaluation",
  fakta: "Info",
  geogebra: "GeoGebra",
  lærervejledning: "Teacher’s guide",
  læseguide: "Reading guide",
  "mundtlig-opgave": "Speak",
  mål: "Goal",
  opgave: "Task",
  gruppe: "In groups",
  alene: "By yourself",
  klasse: "In class",
  par: "In pairs",
  "skriftlig-opgave": "Write",
  spil: "Play",
  udfordring: "Challenge",
  undersøgelse: "Explore"
};
const germanLabels = {
  aktivitet: "Aktivität",
  bevægelse: "Bewegung",
  citat: "Zitat",
  eksempel: "Beispiel",
  evaluering: "Evaluieren",
  fakta: "Fakten",
  geogebra: "GeoGebra",
  lærervejledning: "LehrerIn",
  læseguide: "Leseguide",
  "mundtlig-opgave": "Sprechen",
  mål: "Ziele",
  opgave: "Aufgabe",
  gruppe: "Gruppenarbeit",
  alene: "Einzelarbeit",
  klasse: "Klassenarbeit",
  par: "Paararbeit",
  "skriftlig-opgave": "Schreiben",
  spil: "Spielen",
  udfordring: "Herausforderung",
  undersøgelse: "Untersuchen"
};
const frenchLabels = {
  aktivitet: "Activité",
  bevægelse: "Bouger",
  citat: "Citation",
  eksempel: "Exemple",
  evaluering: "Évaluation",
  fakta: "Faits",
  geogebra: "GeoGebra",
  lærervejledning: "Pour le professeur",
  læseguide: "Guide de lecture",
  "mundtlig-opgave": "Parler",
  mål: "Objectif",
  opgave: "Exercice",
  gruppe: "Travail de groupe",
  alene: "Travail individuel",
  klasse: "Travail en classe",
  par: "Travail à 2",
  "skriftlig-opgave": "Écrire",
  spil: "Jouer",
  udfordring: "Challenge",
  undersøgelse: "Explorer"
};

export { stringifyRibbonLabel };
//# sourceMappingURL=stringify-ribbon-label.js.map
